/**
 * Rotas das telas de autenticação, por hash: funcionam em qualquer hospedagem
 * estática sem configurar fallback no servidor. O link do e-mail aponta para `#/reset/<token>`.
 */
export const authRoutes = {
  login: '#/login',
  forgot: '#/forgot',
  reset: (token: string): string => `#/reset/${token}`,
} as const;

export type AuthRoute =
  | { screen: 'login' }
  | { screen: 'forgot' }
  | { screen: 'reset'; token: string };

export function parseAuthRoute(hash: string = location.hash): AuthRoute {
  const m = /^#\/reset\/([A-Za-z0-9]+)$/.exec(hash);
  if (m) return { screen: 'reset', token: m[1] as string };
  if (hash === '#/forgot') return { screen: 'forgot' };
  return { screen: 'login' };
}

export const isAuthHash = (hash: string = location.hash): boolean => /^#\/(login|forgot|reset\/)/.test(hash);

/** Limpa o hash sem recarregar nem deixar entrada no histórico. */
export function clearAuthHash(): void {
  if (isAuthHash()) history.replaceState(null, '', location.pathname + location.search);
}
